import { useCallback, useEffect } from 'react';
import { useAsync } from '@nxsys/hooks/useAsync';
import { getAnalyticsPaymentsTaxPeriod } from '@nxsys/services/api/analytics';
import type {
  GetAnalyticsPaymentsTaxPeriodResponse,
  GetAnalyticsPayslipsProcessedListParams,
} from '@nxsys/types/api/analytics';
import { showMessage } from '@nxsys/utils/message';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

type UseGetPaymentsTaxPeriodReturn = {
  loading: boolean;
  error: Error | null;
  data: GetAnalyticsPaymentsTaxPeriodResponse | null;
  fetchPaymentsTaxPeriod: () => Promise<void>;
};

export const useGetPaymentsTaxPeriod = (
  params?: GetAnalyticsPayslipsProcessedListParams,
): UseGetPaymentsTaxPeriodReturn => {
  const {
    loading,
    error,
    value: data,
    run,
  } = useAsync<GetAnalyticsPaymentsTaxPeriodResponse, void>(() =>
    getAnalyticsPaymentsTaxPeriod(params),
  );

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  const fetchPaymentsTaxPeriod = useCallback(async () => {
    await run(undefined);
  }, [run]);

  return {
    loading,
    error,
    data,
    fetchPaymentsTaxPeriod,
  };
};
